import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"center"} }
const _hoisted_2 = { style: {"font-size":"22px","margin-left":"0.5rem"} }

import IconComponent from "@/components/app/_shared/icons/icon-component.vue";
import BrandIconButton from "@/components/common-ui/buttons/BrandIconButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListHead',
  props: {
  rightGap: {
    type: Boolean,
    default: true,
  },
},
  emits: ["shuffle"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({ marginRight: props.rightGap ? '1rem' : '0' })
    }, [
      _renderSlot(_ctx.$slots, "panel", {}, () => [
        _createVNode(BrandIconButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('shuffle')))
        }, {
          icon: _withCtx(() => [
            _createVNode(IconComponent, {
              lib: "filoxenia",
              icon: "MixArrows"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_ctx.$t("audio.controls.shuffle")), 1)
          ]),
          _: 1
        })
      ])
    ], 4)
  ]))
}
}

})